import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
}: SectionHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 flex items-center gap-2.5">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          {title}
        </h2>
        {subtitle ? <p className="mt-2 text-sm text-foreground-500">{subtitle}</p> : null}
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      ) : null}
    </div>
  );
}